import { useEffect, useState } from 'react';

import chessPlaza from './assets/chess_plaza.webp';
import research from './assets/research.webp';
import chess from './assets/chess.webp';
import fall from './assets/fall_colors.webp';
import TIPlaza from './assets/ti_plaza.webp';
import UTDesign from './assets/UT_Design.webp';
import plinth from './assets/plinth.webp';
import baseball from './assets/baseball.webp';
import animation_class from './assets/class.webp';
import studying from './assets/studying.webp';

import CardButton from './components/CardButton';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import Autoplay from 'embla-carousel-autoplay';

function App() {
  const cardData = [
    { title: 'Net ID', description: 'Set up your account, reset your password, and manage your account.', logo: 'badge', link: 'https://oit.utdallas.edu/netid/' },
    { title: 'GET Portal', description: 'Check or add to your CometCash balance.', logo: 'payments', link: 'https://get.cbord.com/utdallas/full/login.php' },
    { title: 'Galaxy', description: 'Access Orion, Gemini systems, email, and eLearning through Galaxy.', logo: 'apps', link: 'https://galaxy.utdallas.edu/' },
    { title: 'Campus Map', description: 'Find your classroom and navigate campus with the interactive map.', logo: 'map', link: 'https://www.utdallas.edu/maps' },
    { title: 'Atlas Portal', description: "Atlas is the university's central service catalog and knowledge base.", logo: 'menu_book', link: 'https://atlas.utdallas.edu/' },
    { title: 'New to UT Dallas?', description: 'Explore account information, online resources, and departments of interest.', logo: 'school', link: 'https://www.utdallas.edu/oit/studentinfo' },
  ];

  const carouselImages = [chessPlaza, research, fall, chess, plinth, UTDesign, TIPlaza, baseball, animation_class, studying];

  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const formattedDate = new Intl.DateTimeFormat('en-US', { weekday: 'long', month: 'long', day: 'numeric' }).format(currentTime);
  const formattedTime = currentTime.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });

  return (
    <div className="flex h-screen">
      {/* Left Panel */}
      <div className="relative w-1/2 min-w-[50vw]">
        <Carousel opts={{ loop: true }} plugins={[Autoplay({ delay: 10000 })]}>
          <CarouselContent>
            {carouselImages.map((image, index) => (
              <CarouselItem key={index}>
                <img
                  src={image}
                  alt={`Slide ${index + 1}`}
                  className="min-h-screen bg-cover object-cover"
                  loading="lazy"
                />
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselPrevious className="absolute left-2 top-1/2 z-[9] -translate-y-1/2 transform border-2 border-utdGreen bg-white text-utdGreen hover:bg-utdGreen hover:text-white" />
          <CarouselNext className="absolute right-2 top-1/2 z-[9] -translate-y-1/2 transform border-2 border-utdGreen bg-white text-utdGreen hover:bg-utdGreen hover:text-white" />
        </Carousel>

        {/* UTD Logo */}
        <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
          <img
            src="https://websvcs.utdallas.edu/shared/svg/utd-emblem-2color.svg"
            alt="UTD"
            className="h-48 w-48 opacity-60"
          />
        </div>
      </div>

      {/* Right Panel */}
      <div className="flex h-full w-1/2 min-w-[550px] flex-col items-center justify-center bg-white py-8">
        {/* Timestamp */}
        <div className="mb-8 text-center">
          <p className="text-2xl text-gray-600">{formattedDate}</p>
          <p className="text-5xl font-bold text-gray-800">{formattedTime}</p>
        </div>

        {/* Logo */}
        <img
          src="https://websvcs.utdallas.edu/shared/svg/utd-wordmark-2line-orange.svg"
          alt="The University of Texas at Dallas"
          className="w-100 mb-4 h-32"
        />

        <h1 className="mb-4 text-3xl font-bold text-utdGreen">OIT TechKnowledgy Bar</h1>

        <p className="mb-8 px-4 text-center text-xl text-gray-600">
          Explore the resources and services provided by the Office of Information Technology.
        </p>

        {/* Buttons */}
        <div className="grid w-full max-w-4xl grid-cols-2 gap-6 px-4">
          {cardData.map((card, index) => (
            <CardButton
              key={index}
              title={card.title}
              description={card.description}
              logo={card.logo}
              link={card.link}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default App;
